<h1 mat-dialog-title>{{ data.partner.label }} played rooms for {{ data.user.realName || data.user.displayName }}</h1>
<mat-dialog-content>
  <div *ngIf="loading" class="flex-row gap-10 loading">
    <mat-spinner diameter="24"></mat-spinner>
    <span *ngIf="!response">Asking {{ data.partner.label }} about user {{ partnerUserId }}…</span>
    <span *ngIf="response">Matching {{ response.rooms.length }} room{{ response.rooms.length === 1 ? '' : 's' }} against TERPECA…</span>
  </div>

  <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>

  <ng-container *ngIf="result && !loading">
    <div class="flex-col gap-5 summary">
      <div>
        <i><b>{{ data.partner.label }} user: </b></i>
        <a *ngIf="profileUrl; else plainId" [href]="profileUrl" target="_blank">{{ result.userid }}</a>
        <ng-template #plainId>{{ result.userid }}</ng-template>
        <ng-container *ngIf="response?.name">
          — they call them <b>{{ response.name }}</b>; we call them <b>{{ data.user.realName || data.user.displayName }}</b>
        </ng-container>
      </div>
      <div>
        <i><b>Response: </b></i>
        HTTP {{ result.status }} in {{ result.elapsedMs }} ms
        <ng-container *ngIf="response">
          · {{ rows.length }} room{{ rows.length === 1 ? '' : 's' }}
          <ng-container *ngIf="maybePlayedCount"> · {{ maybePlayedCount }} maybe played</ng-container>
          <ng-container *ngIf="flaggedCount"> · <span class="flagged">{{ flaggedCount }} flagged</span></ng-container>
          <ng-container *ngIf="unresolvedCount"> · <span class="unresolved">{{ unresolvedCount }} unknown id{{ unresolvedCount === 1 ? '' : 's' }}</span></ng-container>
          · awards version {{ response.awardsVersion || 'not ready (0)' }}
        </ng-container>
        <ng-container *ngIf="!response"> · not a played-rooms response (see raw body below)</ng-container>
      </div>
      <div *ngIf="result.translation as t">
        <i><b>Translated: </b></i>
        from {{ data.partner.label }}'s own room ids using our mapping
        <ng-container *ngIf="t.private"> · <span class="unresolved">their profile is private, so no rooms were sent</span></ng-container>
        <ng-container *ngIf="t.unmapped"> · {{ t.unmapped }} played room{{ t.unmapped === 1 ? '' : 's' }} not in our mapping</ng-container>
        <ng-container *ngIf="t.upcoming"> · {{ t.upcoming }} upcoming booking{{ t.upcoming === 1 ? '' : 's' }} left out</ng-container>
      </div>
    </div>

    <table *ngIf="rows.length" mat-table [dataSource]="rows" class="mat-elevation-z2 rooms">
      <ng-container matColumnDef="ourRoom">
        <th mat-header-cell *matHeaderCellDef>TERPECA room</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.room; else unknownRoom">
            <div>{{ roomLabel(row.room) }}</div>
            <div class="secondary">{{ row.room.company }} · {{ roomLocation(row.room) }}</div>
          </ng-container>
          <ng-template #unknownRoom><span class="unresolved">unknown id {{ row.entry.terpecaID }}</span></ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="theirRoom">
        <th mat-header-cell *matHeaderCellDef>{{ data.partner.label }} room</th>
        <td mat-cell *matCellDef="let row">
          <div>{{ row.entry.name || '—' }}</div>
          <div *ngIf="row.entry.company" class="secondary">{{ row.entry.company }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Awards</th>
        <td mat-cell *matCellDef="let row">{{ row.awardStatus }}</td>
      </ng-container>
      <ng-container matColumnDef="rank">
        <th mat-header-cell *matHeaderCellDef class="num">Rank</th>
        <td mat-cell *matCellDef="let row" class="num">{{ row.entry.rank ?? '' }}</td>
      </ng-container>
      <ng-container matColumnDef="rating">
        <th mat-header-cell *matHeaderCellDef class="num">Rating</th>
        <td mat-cell *matCellDef="let row" class="num">{{ row.entry.rating ?? '' }}</td>
      </ng-container>
      <ng-container matColumnDef="flags">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.entry.maybePlayed" class="chip">maybe played</span>
          <span *ngIf="row.entry.flagged" class="chip flagged">flagged</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <a *ngIf="row.entry.url" [href]="row.entry.url" target="_blank" matTooltip="Open on {{ data.partner.label }}">
            <mat-icon>open_in_new</mat-icon>
          </a>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns" [class.flagged-row]="row.entry.flagged"></tr>
    </table>

    <div *ngIf="response && !rows.length" class="empty">{{ data.partner.label }} has no rooms recorded for this user.</div>

    <mat-expansion-panel class="raw">
      <mat-expansion-panel-header>
        <mat-panel-title>Raw response{{ result.translation ? ' (before translation)' : '' }}</mat-panel-title>
        <mat-panel-description>{{ result.url }} · {{ result.contentType || 'no content type' }}</mat-panel-description>
      </mat-expansion-panel-header>
      <pre>{{ rawBody || '(empty body)' }}</pre>
    </mat-expansion-panel>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
